import { render, staticRenderFns } from "./entity-panel.vue?vue&type=template&id=113ce714&scoped=true"
import script from "./entity-panel.vue?vue&type=script&lang=ts"
export * from "./entity-panel.vue?vue&type=script&lang=ts"
import style0 from "./entity-panel.vue?vue&type=style&index=0&id=113ce714&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113ce714",
  null
  
)

export default component.exports